export enum JustificationFilterOptions {
    All = 0,
    Required = 1,
    Available = 2,
}
